import * as React from 'react';
import EnhancedTable, {ColumnDescriptor, TableRecord} from "../../common/table/EnhancedTable";
import ClassThumbState from "./thumb/ClassThumbState";
import {css, StyleSheet} from "aphrodite";

interface NewClassesListProps {
    onSelect: (id: string[]) => void;
    classes: TableRecord[];
}

interface  NewClassesListState {
    classIdList: string[];
    classStateList: ClassThumbState[];
}

/**
 * This element acts as a wrapper/controller. It grabs data from firestore and pushes it to
 * our table.
 */
class NewClassesList extends React.Component<NewClassesListProps, NewClassesListState> {

    constructor(props: NewClassesListProps) {
        super(props);
        this.state = {
            classIdList : [],
            classStateList: [],
        };
    }

    public render() {
        const columns: ColumnDescriptor[] = [
            { id: 'timestamp', type: 'timestamp', label: "Date", sort: true},
            { id: 'availableForReplay', label: "availableForReplay", sort: true, type: "boolean"},
            { id: 'thumbURL', type: 'image', label: "Thumbnail", sort: false},
        ];
        return (
            <div className={css(styles.root)}>
                <EnhancedTable
                    data={this.props.classes}
                    columns={columns}
                    allowSelectAll={false}
                    onSelect={this.props.onSelect}
                    allowDelete={false}
                    allowFilter={false}
                    dense={true} />
            </div>
        );
    }
}

const styles = StyleSheet.create({
    root: {
        marginTop: "40px",
    }
});


export default NewClassesList;


// WEBPACK FOOTER //
// ./src/components/replay/classes/NewClassesList.tsx